import { memo } from 'react'

import { Wrapper, Spinner } from './styles'
import { ButtonProps } from './types'

const Button = ({ children, loading, variant, color, ...rest }: ButtonProps) => (
  <Wrapper {...rest} loading={loading ? 1 : 0} variant={variant} color={color}>
    {loading ? <Spinner variant={variant} color={color} /> : children}
  </Wrapper>
)

export default memo(Button)
